
import { useEffect, useState } from "react"
import { useHistory } from 'react-router-dom';
import { updateSentryForMFE } from '../utils/sentry';
import { detectLocale } from '../utils/localeUtils';

export const useModFed = (rootID: string, importRemote) => {
  const history = useHistory();
  const localeCountryCode = detectLocale();
  console.log('🌍 shell app: Locale country code detected:', localeCountryCode);
  
  const [config] = useState({
    defaultHistory: history,
    onNavigate: ({ pathname: nextPath }) => {
      const { pathname } = history.location;
      if (pathname !== nextPath) {
        history.push(nextPath);
      }
    },
    updateSentryForMFE,
    localeCountryCode,
  });

  useEffect(() => {
    let unmountFunc;
    const mountAMS = async() => {
      const module = await importRemote();
      const {onParentNavigate, unmount} = module.default(document.getElementById(rootID), config);
      unmountFunc = unmount;
      if (config.defaultHistory && onParentNavigate) {
        config.defaultHistory.listen(onParentNavigate);
      }
    }
    mountAMS();

    return () => {
      if (unmountFunc) {
        unmountFunc();
      }
    };

  },[])
}
